import React from "react";

/**
 * PageHeader — gradient header shown at the top of every page.
 * Sits ABOVE the page toolbar (mid-tab). Contains title + optional
 * page-scoped tools like print, export, help, refresh.
 *
 * Props:
 *   icon      — bootstrap-icons class for the leading icon
 *   title     — main title string
 *   subtitle  — small helper text below title
 *   tools     — React node rendered in the right slot (usually <ToolbarButton/> items)
 */
const PageHeader = ({ icon = "bi-layers", title, subtitle, tools }) => {
  return (
    <header className="ds-page-header">
      <div>
        <h1 className="ds-page-header__title">
          {icon && <i className={`bi ${icon} me-2`} />}
          {title}
        </h1>
        {subtitle && <div className="ds-page-header__subtitle">{subtitle}</div>}
      </div>
      {tools && <div className="ds-page-header__tools">{tools}</div>}
    </header>
  );
};

export default PageHeader;
